/*
 * Module for category info
 */

define([
  "marionette",
  "underscore",
  "backbone",
  "messaging/messenger",
  "./categoryInfoView",
], function (Marionette, _, Backbone, Messenger, CategoryInfoView) {
  var CategoryInfoController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "categoryInfo";
      this.namespace = options.namespace;
      this.region = options.region;
      this.responseId = options.responseId;
      this._setUpVents();
      this.insertType = "csv";
    },

    show: function (categoryId) {
      this.viewModel = new Backbone.Model();
      this.categoryId = categoryId;
      try {
        this.topicCategories = Messenger.reqres.request("fetch:conversation:response:categories");
      } catch (e) {
        this.topicCategories = new Backbone.Collection();
      }
      this.topicCategories.onSynced(function () {
        var categoryValues = new Backbone.Collection(
          this.topicCategories.where({ categoryId: categoryId }),
        );
        categoryValues.comparator = function (a, b) {
          return Backbone.textComparator(a, b, "categoryValue");
        };
        categoryValues.sort();
        this.viewModel.set("matchingCategoryValues", categoryValues);
        this.viewModel.set("insertType", this.insertType);
        this.layout = new CategoryInfoView.categoryInfoLayout({ model: this.viewModel });
        this.showRegion(this.layout);
      }, this);
    },

    _setUpVents: function () {
      Messenger.vent.on(
        Messenger.getFullName("show:categoryInfo", this.namespace),
        function (category) {
          this.show(category.get("categoryId"));
        },
        this,
      );

      Messenger.vent.on(
        Messenger.getFullName("category:insert:type:selected", this.namespace),
        function (insertType) {
          this.insertType = insertType;
          this.show(this.attributeId);
        },
        this,
      );
    },
  });

  return CategoryInfoController;
});
